import { render, staticRenderFns } from "./AlertEditForm.vue?vue&type=template&id=4753e89a"
import script from "./AlertEditForm.vue?vue&type=script&lang=js"
export * from "./AlertEditForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports